// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"3daeb033","977":"d86e0608"}[chunkId] + ".chunk.js";
};